import { Screen } from '../interfaces';
export const CharacterSelect: Screen = {
  component: 'profile-select',
  key: 'character'
};
export const JobSelect: Screen = {
  component: 'profile-select',
  key: 'job'
};
